import gql from 'graphql-tag'

export const ALL_NAVIGATION = gql`
  query AllNavigation($code: String!, $concessionEnabled: Boolean! = false) {
    header(code: $code, concessionEnabled: $concessionEnabled) @client {
      navigation {
        topLevel {
          displayName
          type
          link {
            text
            url
            openExternally
            noFollow
            noIndex
          }
          image {
            url
            alt
          }
          subNavigation {
            displayName
            type
            link {
              text
              url
              openExternally
              noFollow
              noIndex
            }
            image {
              url
              alt
            }
            subNavigation {
              displayName
              type
              link {
                text
                url
                openExternally
                noFollow
                noIndex
              }
              image {
                url
                alt
              }
            }
          }
        }
      }
      widgets @client {
        id
        ... on ResponsiveUSPBar {
          callIcon
          callLink
          callText
          checkmarkLink
          checkmarkText
          clickAndCollectLink
          clickAndCollectText
          countDownLink
          countDownText
          deliveryText
          deliveryLink
          emailLink
          emailText
          fastTrackLink
          fastTrackText
          internationalDeliveryLink
          internationalDeliveryText
          qualityLink
          qualityText
          rewardPointsLink
          rewardPointsText
          storeLink
          storeText
          timezoneOffset
          trustPilotLink
          trustPilotText
          mondayCutoff
          tuesdayCutoff
          wednesdayCutoff
          thursdayCutoff
          fridayCutoff
          saturdayCutoff
          sundayCutoff
        }
        ... on GlobalStripBanner {
          stripBannerTextPLP
          stripBannerURL
          stripBannerURLPDP
          stripBannerURLHomepage
          stripBannerText
          stripBannerURLBasket
          stripBannerTextPDP
          stripBannerURLAccount
          stripBannerTextBasket
          stripBannerTextAccount
          stripBannerURLPLP
          stripBannerTextHomepage
        }
        __typename
      }
    }
    footer(code: $code, concessionEnabled: $concessionEnabled) @client {
      navigation {
        topLevel {
          type
          link {
            url
            text
          }
          displayName
          iconName
          subNavigation {
            type
            link {
              url
              text
            }
            displayName
            iconName
          }
        }
      }
    }
    socialAccounts @client {
      url
      socialNetwork
    }
    paymentMethods @client
    brands @client {
      name
      page {
        path
      }
    }
  }
`

export const INSTANT_SEARCH = gql`
  query instantSearch(
    $query: String!
    $currency: Currency!
    $shippingDestination: Country!
    $limit: Int!
    $concessionCode: String
  ) {
    instantSearch(
      query: $query
      currency: $currency
      shippingDestination: $shippingDestination
      limit: $limit
      concessionCode: $concessionCode
    ) @client {
      products {
        sku
        title
        url
        reviews {
          total
          averageScore
        }
        images {
          thumbnail
          largeProduct
          zoom
        }
        price @client {
          price {
            displayValue
          }
          hasFromPrice
        }
      }
      corrections {
        correction
        highlightedSearchCorrection
      }
      suggestedSearchQueries
    }
  }
`

export const HEADER_NAVIGATION = gql`
  query header($code: String!, $concessionEnabled: Boolean! = false) {
    header(code: $code, concessionEnabled: $concessionEnabled) @client {
      navigation {
        topLevel {
          displayName
          type
          link {
            text
            url
            openExternally
            noFollow
            noIndex
          }
          image {
            url
            alt
          }
          subNavigation {
            displayName
            type
            link {
              text
              url
              openExternally
              noFollow
              noIndex
            }
            image {
              url
              alt
            }
            subNavigation {
              displayName
              type
              link {
                text
                url
                openExternally
                noFollow
                noIndex
              }
              image {
                url
                alt
              }
            }
          }
        }
      }
    }
  }
`

export const BRANDS = gql`
  query brands {
    brands @client {
      name
      page {
        path
      }
    }
  }
`

export const BASKET = gql`
  query MiniBasket(
    $id: ID
    $currency: Currency!
    $shippingDestination: Country!
    $productContentKeys: [String!]
    $wishlistEnabled: Boolean
    $loyaltyEnabled: Boolean
  ) {
    basket(
      id: $id
      currency: $currency
      shippingDestination: $shippingDestination
      productContentKeys: $productContentKeys
      wishlistEnabled: $wishlistEnabled
      loyaltyEnabled: $loyaltyEnabled
    ) @client {
      totalQuantity
      items {
        product {
          title
          product {
            sku
            url
            images {
              largeProduct
            }
          }
        }
        quantity
        standardPricePerUnit {
          displayValue
          amount
        }
        freeGift
      }
      chargePrice {
        displayValue
        amount
      }
      earnableLoyaltyPoints
    }
  }
`
